import cn from "classnames";
import Styles from "./OldGrid.module.scss";

interface Props {
  children: JSX.Element | JSX.Element[];
  className?: string;
  centered?: boolean;
  padded?: boolean;
  fillPage?: boolean;
  "data-testid"?: string;
}

export const OldGrid = ({
  className,
  children,
  padded,
  centered = true,
  fillPage,
  ...props
}: Props) => (
  <div
    data-testid={props["data-testid"]}
    className={cn(
      Styles.grid,
      {
        [Styles.padded]: padded,
        [Styles.centered]: centered,
        [Styles.fillPage]: fillPage,
      },
      className
    )}
  >
    {children}
  </div>
);
